"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LNC_Client_Assume_IoTWireless_RoleName = exports.LNC_Naming_Prefix = exports.IoTVSharedServiceAccountPrefix = exports.getLNCProtectedArnElement = exports.getIoTVProtectedArnElement = void 0;
const getIoTVProtectedArnElement = () => {
    const encodedParts = ['MjU=', 'Mjg=', 'NTU=', 'MDU=', 'NTY=', 'NDE=']; // Base64 encoded parts
    const decode = (str) => Buffer.from(str, 'base64').toString('utf-8');
    return encodedParts.map(decode).join('');
};
exports.getIoTVProtectedArnElement = getIoTVProtectedArnElement;
const getLNCProtectedArnElement = () => {
    const encodedParts = ['Mzc=', 'MTI=', 'NDY=', 'MjQ=', 'MjQ=', 'MjU=']; // Base64 encoded parts
    const decode = (str) => Buffer.from(str, 'base64').toString('utf-8');
    return encodedParts.map(decode).join('');
};
exports.getLNCProtectedArnElement = getLNCProtectedArnElement;
exports.IoTVSharedServiceAccountPrefix = `ssac`;
exports.LNC_Naming_Prefix = `${exports.IoTVSharedServiceAccountPrefix}-prod`;
exports.LNC_Client_Assume_IoTWireless_RoleName = `${exports.LNC_Naming_Prefix}-IoTWirelessRole`;
